import React from "react";
import { Gift } from "lucide-react";

export default function PromoBanner() {
  return (
    <div
      data-testid="gold-jersey-banner"
      className="rounded-2xl border-2 border-[#F3C242] gold-glow bg-gradient-to-r from-[#03281B] via-[#054D34] to-[#03281B] px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4"
    >
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#F3C242] flex items-center justify-center text-[#03281B]">
          <Gift size={24} />
        </div>
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#F3C242]">Exclusive Gift</div>
      </div>
      <div className="flex-1">
        <p className="text-white font-semibold">
          The first 5 registrations receive a retro Cristiano Ronaldo Sporting CP replica jersey!
        </p>
      </div>
    </div>
  );
}
